import { useState } from "react";

import { ActionsMenu, ActionsMenuButton, MenuItem } from "ui/actions-menu";

import Icons from "assets";
import ControlBar from "components/partials/control-bar/control-bar";

interface ProgramTemplatesContextMenuProps {
  allSelectedAmount: number;
  totalTemplates: number;
  hasApprovedSelected: boolean;
  onCloneTemplates?: () => void;
  onCreateTouchpointsFromTemplates?: () => void;
  onArchiveTemplates?: () => void;
}

const ProgramTemplatesContextMenu = ({
  allSelectedAmount,
  totalTemplates,
  hasApprovedSelected,
  onCloneTemplates,
  onCreateTouchpointsFromTemplates,
  onArchiveTemplates,
}: ProgramTemplatesContextMenuProps) => {
  const [isActionsDropdownOpen, setIsActionsDropdownOpen] = useState(false);

  const handleActionsDropdownOpen = () => setIsActionsDropdownOpen(true);
  const handleActionsDropdownClose = () => setIsActionsDropdownOpen(false);

  if (!allSelectedAmount) {
    return null;
  }

  const handleCloneTemplates = () => onCloneTemplates?.();

  const handleCreateTouchpointsFromTemplates = () => onCreateTouchpointsFromTemplates?.();

  const handleArchiveTemplates = () => {
    onArchiveTemplates?.();
    handleActionsDropdownClose();
  };

  return (
    <ControlBar variant="inset">
      <div className="flex items-center">
        <span className="text-gray-900 text-sm px-3">
          Selected {allSelectedAmount} of {totalTemplates} items
        </span>

        <ActionsMenu
          itemName="selected program templates"
          open={isActionsDropdownOpen}
          onOpen={handleActionsDropdownOpen}
          onClose={handleActionsDropdownClose}
          offsetLeft={2}
          offsetTop={10}
          trigger={
            <ActionsMenuButton variant="outlined" size="large">
              Actions
            </ActionsMenuButton>
          }>
          <MenuItem
            icon={<Icons.Clone />}
            label="Clone templates"
            onClick={handleCloneTemplates}
          />
          <MenuItem
            icon={<Icons.Creatives />}
            label="Create from templates"
            onClick={handleCreateTouchpointsFromTemplates}
            disabled={!hasApprovedSelected}
            tooltip={
              !hasApprovedSelected
                ? "Please select at least one approved template"
                : undefined
            }
          />
          <MenuItem
            icon={<Icons.Archive />}
            label="Archive templates"
            color="error"
            onClick={handleArchiveTemplates}
          />
        </ActionsMenu>
      </div>
    </ControlBar>
  );
};

export default ProgramTemplatesContextMenu;
